import React, { useState } from 'react';
import './Node.css';
const placeholderPic = require('../../assets/images/placeholder3.png')

const Node = ({ id, name, x, y, subject, onClick, onEnter, onLeave, tags = [], topicStatus = 0, nextNode = false }) => {

    const [isHovered, setIsHovered] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const colors = ["#666666", "#e67300", "#63ad55", "#566cae"];
    const shadow_colors = ["#4d4d4d", "#b35900", "#528e46", "#475990"];

    const tagElements = tags.map((tag, index) => (
        <span key={index} className="tags" style={{ backgroundColor: shadow_colors[topicStatus] }}>
            {tag}
        </span>
    ));

    let boxShadowValue = `0px 6px 0px 0px ${shadow_colors[topicStatus]}, 0px 6px 10px 5px rgba(0, 0, 0, 0.1)`;
    let transformValue = 'none';
    let cursorValue = 'pointer';
    let animation = 'jumpAnimation 4s ease infinite';

    if (isHovered) {
        boxShadowValue = `0px 9px 0px 0px ${shadow_colors[topicStatus]}, 0px 9px 10px 5px rgba(0, 0, 0, 0.1)`;
        transformValue = 'translateY(-3px)';
        animation = 'none';
    }

    if (isActive) {
        boxShadowValue = `0px 3px 0px 0px ${shadow_colors[topicStatus]}, 0px 3px 10px 5px rgba(0, 0, 0, 0.1)`;
        transformValue = 'translateY(3px)';
        cursorValue = 'pointer';
        animation = 'none';
    }

    const containerClass = `node-container${nextNode ? ' next-node-animated' : ' no-animation'}`;

    return (
        <div onClick={() => onClick(id)} onMouseEnter={() => onEnter(id)} onMouseLeave={() => onLeave()} className="node" style={{ left: x, top: y }}>
            <div
                className={containerClass}
                style={{
                    backgroundColor: colors[topicStatus],
                    boxShadow: boxShadowValue,
                    transform: transformValue,
                    cursor: cursorValue,
                    '--shadow-color': shadow_colors[topicStatus],
                    animation: animation,
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onMouseDown={() => setIsActive(true)}
                onMouseUp={() => setIsActive(false)}
                onBlur={() => setIsActive(false)}
            >
                <div className="node-content">
                    <div className="node-label">
                        <div className="topic-name">{name}</div>
                        {tags && tags.length > 0 && <div>{tagElements}</div>}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Node;